import React, { createContext, useContext, useState, useEffect } from 'react';
import messageService from '../services/messageService';

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(0);

  // Function to fetch unread message count
  const fetchUnreadCount = async () => {
    setLoading(true);
    try {
      const response = await messageService.getUnreadCount();
      if (response.success && response.data) {
        setUnreadCount(response.data.count || 0);
      }
    } catch (error) {
      console.error('Error fetching unread message count:', error);
    } finally {
      setLoading(false);
    }
  };

  // Function to mark a message as read and update the count
  const markMessageAsRead = async (messageId) => {
    try {
      const response = await messageService.markMessageAsRead(messageId);
      if (response.success) {
        // Reduce the count only if it's greater than 0
        setUnreadCount(prev => (prev > 0 ? prev - 1 : 0));
      }
      return response;
    } catch (error) {
      console.error('Error marking message as read:', error);
      throw error;
    }
  };

  // Function to manually trigger a refresh of the unread count
  const refreshUnreadCount = () => {
    setLastUpdated(Date.now());
  };

  useEffect(() => {
    // Fetch unread count on mount and when lastUpdated changes
    fetchUnreadCount();
    
    // Set up interval to check for new messages (every 30 seconds)
    const interval = setInterval(() => {
      fetchUnreadCount();
    }, 30000);
    
    return () => clearInterval(interval);
  }, [lastUpdated]);

  return (
    <MessageContext.Provider value={{ 
      unreadCount, 
      loading, 
      markMessageAsRead,
      refreshUnreadCount
    }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessages = () => useContext(MessageContext);

export default MessageContext;